import { render, staticRenderFns } from "./JdsBreakdown.vue?vue&type=template&id=c3594c68&scoped=true&"
import script from "./JdsBreakdown.vue?vue&type=script&lang=ts&"
export * from "./JdsBreakdown.vue?vue&type=script&lang=ts&"
import style0 from "./JdsBreakdown.vue?vue&type=style&index=0&id=c3594c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3594c68",
  null
  
)

export default component.exports